'use strict'

class SearchFilter {
  constructor() {
  	this.getCount = null;
    this.url = new URL(window.location.href);
		this.topic = this.url.searchParams.get("topic");
		this.search = this.url.searchParams.get("search");
		this.role = this.url.searchParams.get("role");
		this.contentFormat = this.url.searchParams.get("content-format");
		this.element  = document.getElementById('body');
		this.podcastTopic = this.url.searchParams.get("ltopic");
		this.contentType = this.url.searchParams.get("content_type");
		this.podcastRole = this.url.searchParams.get("lrole");
		this.podcastContentFormat = this.url.searchParams.get("lcontent-format");
		this.podcastSpeaker = this.url.searchParams.get("lspeaker");
		this.authors = this.url.searchParams.get("author-id");
		this.guestAuthors = this.url.searchParams.get("guest-id");
  }

  init() {
    if(this.search || this.topic || this.role || this.contentType || this.contentFormat || this.podcastTopic || this.podcastRole || this.podcastContentFormat || this.podcastSpeaker || this.authors || this.guestAuthors) {
			this.element.classList.add("search-results");
			this.getCount = document.getElementsByClassName('tps-grid-item').length;
			if(!this.getCount) {
				this.getCount = document.getElementsByClassName('resource-post-container-items-item').length;
			}
		 	this.addResults_Count();
		}
  }
  addResults_Count() {
  	 jQuery('.tps-resource-search-container #total-post-count').text(this.getCount);
  }
}